.supportBlock {
  display: flex;
  width: 100%;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 32px;
  background: #F3EDDF;

  h3 {
    color: #231E19;
    font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
    font-size: 19px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.076px;
    margin-bottom: 8px;
  }

  p,
  a {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.045px;
  }

  p {
    color: #7B766F;
  }

  a {
    color: var(--ed-brand, #BA61FE);
  }
}

// Dark mode
:global body.dark {
  :local {

    .supportBlock {
      background: #2A2928;

      h3 {
        color: #FFFBF2;
      }

      p {
        color: #8B8984;
      }
    }

  }
}

:global body.dark #secondScreenWrapper {
  :local {
    .supportBlock {
      background-color: #181716;
    }
  }
}